import type { InputHTMLAttributes } from "react";
import { classNames } from "./classNames";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export function Input({ id, label, error, className, ...props }: InputProps) {
  const inputId = id ?? label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  const errorId = `${inputId}-error`;

  return (
    <label className="block" htmlFor={inputId}>
      <span className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</span>
      <input
        id={inputId}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? errorId : undefined}
        className={classNames("w-full rounded-xl border border-slate-300 bg-white text-slate-950 px-3 py-2.5 placeholder:text-slate-400 focus:border-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-300", className)}
        {...props}
      />
      {error ? <span className="mt-2 block text-sm font-semibold text-red-600" id={errorId}>{error}</span> : null}
    </label>
  );
}
